import React from "react";

import {
  divisionToNumber,
  HYPER_ROLL_RANKS,
  topRanks,
} from "@/game-tft/constants.mjs";
import globals from "@/util/global-whitelist.mjs";

export function getHyperRollRanksByRating(rating) {
  for (const rank in HYPER_ROLL_RANKS) {
    if (!HYPER_ROLL_RANKS[rank].threshold) continue;
    const minThreshold = HYPER_ROLL_RANKS[rank].threshold.min;
    const maxThreshold = HYPER_ROLL_RANKS[rank].threshold.max;

    if (
      rating &&
      rating >= minThreshold &&
      (maxThreshold === null || rating < maxThreshold)
    ) {
      return HYPER_ROLL_RANKS[rank];
    }
  }
  return HYPER_ROLL_RANKS.NONE;
}

export const useOutsideClick = (callback) => {
  const ref = React.useRef();

  React.useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };
    globals.document.addEventListener("click", handleClick, true);
    return () => {
      globals.document.removeEventListener("click", handleClick, true);
    };
  }, [callback, ref]);
  return ref;
};

export function fixMatchId(platform, matchId) {
  let correctMatchId = matchId;
  if (!matchId.includes("_")) {
    correctMatchId = `${platform.toUpperCase()}_${matchId}`;
  }
  return correctMatchId;
}

export function abbreviateRank(leagueObj) {
  const char = (leagueObj.tier || "").charAt(0);
  const num = divisionToNumber[leagueObj.rank] ?? "";

  if (topRanks.includes(leagueObj.tier)) {
    return char;
  }

  return `${char}${num}`;
}
